import _ from 'underscore'
import {createSelector} from 'reselect/lib/index'
import {ICalLightboxType} from '../../constants'
import {getActiveUsersArray} from '../../../../../js/entities/selectors'
import {convertUsersFilterDependingOnFeatures} from '../../../../../js/atUtils'
import {DEFAULT_FEED_NAME_KEY, DEFAULT_LEAVE_TYPE_SELECTION, DEFAULT_SHARED_WITH_USER_SELECTION, DEFAULT_USER_SELECTION} from './constants'
import {getAllFeedsMap} from '../../selectors'
import messageResource from '../../../../../js/messageResource'
import {getDefaultDateRange} from '../../utils'

const getICalConfiguredFeedState = state => state.iCalendar.configuredFeed

export const getLightBoxType = createSelector(
    getICalConfiguredFeedState,
    state => state.lightboxType
)

export const getEditedFeedId = createSelector(
    getICalConfiguredFeedState,
    state => state.editedFeedId
)

export const getFeedName = createSelector(
    getICalConfiguredFeedState,
    state => state.feedName
)

export const isEditLightBoxSubmitEnabled = createSelector(
    getICalConfiguredFeedState,
    state => !!state.feedName
)

export const getUserSelection = createSelector(
    getICalConfiguredFeedState,
    getActiveUsersArray,
    (state, users) => state.userSelection
                      ? convertUsersFilterDependingOnFeatures
                      (
                          state.userSelection,
                          window.SystemSettings.apUGREnabled,
                          window.SystemSettings.apTZGEnabled,
                          users
                      )
                      : null
)

export const getSharedUserSelection = createSelector(
    getICalConfiguredFeedState,
    getActiveUsersArray,
    (state, users) => state.sharedUserSelection
                      ? convertUsersFilterDependingOnFeatures
                      (
                          state.sharedUserSelection,
                          window.SystemSettings.apUGREnabled,
                          window.SystemSettings.apTZGEnabled,
                          users
                      )
                      : null
)

export const getLeaveTypeSelection = createSelector(
    getICalConfiguredFeedState,
    state => state.feedLeaveTypeSelection
)

export const isIncludesNotApproved = createSelector(
    getICalConfiguredFeedState,
    state => state.includeNotApproved
)

export const getLeaveTypeSelectionForServer = createSelector(
    getLeaveTypeSelection,
    isIncludesNotApproved,
    (leaveTypeSelection, includeNotApproved) => ({
        qualifier: leaveTypeSelection.qualifier,
        leaveTypes: leaveTypeSelection.leaveTypes,
        includeNotApproved,
    })
)

export const getDateRangeSelection = createSelector(
    getICalConfiguredFeedState,
    state => state.dateRangeSelection
)

export const isExportLightBoxShown = createSelector(
    getICalConfiguredFeedState,
    state => state.lightboxType === ICalLightboxType.EXPORT
)

export const isEditLightBoxShown = createSelector(
    getICalConfiguredFeedState,
    state => state.lightboxType === ICalLightboxType.CREATE || state.lightboxType === ICalLightboxType.EDIT
)

export const isDateRangeSelectionValid = createSelector(
    getICalConfiguredFeedState,
    state => state.dateRangeValid
)

const getEditedFeed = createSelector(
    getAllFeedsMap,
    getEditedFeedId,
    (allFeeds, feedId) => allFeeds[feedId]
)

const isCreateFeedDataChanged = createSelector(
    getLightBoxType,
    getFeedName,
    getUserSelection,
    getSharedUserSelection,
    getLeaveTypeSelection,
    isIncludesNotApproved,
    (lightboxType, feedName, userSelection, sharedUserSelection, leaveTypeSelection, includeNotApproved) =>
        lightboxType == ICalLightboxType.CREATE
        && (feedName !== messageResource.getMessage(DEFAULT_FEED_NAME_KEY)
            || userSelection !== DEFAULT_USER_SELECTION
            || sharedUserSelection !== DEFAULT_SHARED_WITH_USER_SELECTION
            || leaveTypeSelection !== DEFAULT_LEAVE_TYPE_SELECTION
            || includeNotApproved)
)

const isEditFeedDataChanged = createSelector(
    getLightBoxType,
    getFeedName,
    getUserSelection,
    getSharedUserSelection,
    getLeaveTypeSelection,
    isIncludesNotApproved,
    getEditedFeed,
    (lightboxType, feedName, userSelection, sharedUserSelection, leaveTypeSelection, includeNotApproved, editedFeed) =>
        lightboxType === ICalLightboxType.EDIT
        && (feedName !== editedFeed.name
            || !_.isEqual(userSelection, editedFeed.usersFilter)
            || !_.isEqual(sharedUserSelection, editedFeed.sharedUsersFilter)
            || leaveTypeSelection.qualifier !== editedFeed.leaveTypesFilter.qualifier
            || !_.isEqual(leaveTypeSelection.leaveTypes, editedFeed.leaveTypesFilter.leaveTypes)
            || includeNotApproved !== editedFeed.leaveTypesFilter.includeNotApproved)
)

export const isEditLightBoxDataChanged = createSelector(
    isCreateFeedDataChanged,
    isEditFeedDataChanged,
    (createFeedDataChanged, editFeedDataChanged) => createFeedDataChanged || editFeedDataChanged
)

export const isExportLightBoxDataChanged = createSelector(
    getLightBoxType,
    getUserSelection,
    getLeaveTypeSelection,
    isIncludesNotApproved,
    getDateRangeSelection,
    (lightboxType, userSelection, leaveTypeSelection, includeNotApproved, dateRangeSelection) =>
        lightboxType === ICalLightboxType.EXPORT
        && (userSelection !== DEFAULT_USER_SELECTION
            || leaveTypeSelection !== DEFAULT_LEAVE_TYPE_SELECTION
            || includeNotApproved
            || dateRangeSelection !== getDefaultDateRange())
)

export const isLightBoxLoading = createSelector(
    getICalConfiguredFeedState,
    state => state.lightboxLoading
)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/selectors.js